import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = {
  class: "tw-mb-10px"
};
var _hoisted_3 = {
  class: "tw-mb-10px"
};
var _hoisted_4 = {
  class: "tw-mb-10px"
};
var _hoisted_5 = {
  class: "tw-mb-10px"
};
var _hoisted_6 = {
  class: "form-group tw-mt-20px tw-mb-30px tw-text-12"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: "e avverr\xE0 il reindirizzamento al sito di pvp.giustizia.it"
}, null, -1 /* HOISTED */);
var _hoisted_11 = {
  key: 1,
  id: "keeper-manager-section",
  class: "tw-mt-20px tw-mb-[80px]"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: "Prenota una visita"
}, null, -1 /* HOISTED */);
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import { computed, ref } from "vue";
import { useValidator } from "@wkComposables/useValidator";
import { useVuelidate } from "@vuelidate/core";
import { alpha, email, numeric, required } from "@vuelidate/validators";
import { replaceAllTokens } from "@utils/StringUtils";
import { sendGAEvent } from "@utils/GaEvents";
import CustodianSupervisorCard from "@vueEntry/CustodianSupervisorCard.vue";
import { sendAgencyContactNoEmailAsync } from "@services/agencyAPI";
import { useMetadataStore } from "@wkWebSrc/js/store";
import md5 from "blueimp-md5";
export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionBookVisitBanner',
  props: {
    labels: {},
    guardian: {},
    supervisor: {},
    isModal: {
      type: Boolean
    },
    referenceId: {},
    agencyId: {},
    pvpLink: {},
    realEstateId: {},
    placeId: {},
    productPrice: {},
    typologyName: {},
    isExtraConsultantActive: {
      type: Boolean
    }
  },
  setup(__props) {
    var props = __props;
    var pvpRedirectIsLoading = ref(false);
    var mdStore = useMetadataStore();
    var requestData = ref({
      name: "",
      surname: "",
      email: "",
      phone: ""
    });
    var v$ = useVuelidate({
      requestData: {
        name: {
          required,
          alpha
        },
        surname: {
          required,
          alpha
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          numeric
        }
      }
    }, {
      requestData
    });
    var {
      isValid
    } = useValidator();
    var redirectToPvp = () => __awaiter(this, void 0, void 0, function* () {
      var isFormValid = yield v$.value.$validate();
      if (!isFormValid) return;
      pvpRedirectIsLoading.value = true;
      var contacts = {
        name: requestData.value.name,
        surname: requestData.value.surname,
        email: requestData.value.email,
        phone: requestData.value.phone,
        notes: "Ho visto questo annuncio all'asta su Wikicasa e vorrei maggiori informazioni",
        referenceId: props.referenceId,
        agencyId: props.agencyId,
        canonicalURL: window._canonicalURL,
        marketingConsent: true
      };
      sendGAEvent("send_form_to_pvp", {
        event_location: mdStore.pageName,
        user_name: requestData.value.name,
        user_surname: requestData.value.surname,
        user_email_hashed: md5(requestData.value.email),
        user_email: requestData.value.email,
        user_phone: requestData.value.phone
      });
      var res = yield sendAgencyContactNoEmailAsync(contacts);
      if (res) pvpRedirectIsLoading.value = false;
      // eslint-disable-next-line max-len
      window.open("https://pvp.giustizia.it/pvp/it/".concat(props.pvpLink, "&prenotazione.cognome=").concat(requestData.value.surname, "&prenotazione.nome=").concat(requestData.value.name, "&prenotazione.email=").concat(requestData.value.email, "&prenotazione.confermaEmail=").concat(requestData.value.email, "&prenotazione.telefono=").concat(requestData.value.phone), "_blank");
    });
    var readAndAcceptedByClicking = computed(() => {
      var placeholder = "{0}";
      var tokens = props.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold tw-lowercase\">").concat(replaceAllTokens(placeholder, {
        "{0}": props.labels.title
      }), "</span>").concat(tokens[1]);
    });
    var privacy_C_section = computed(() => {
      return "".concat(props.labels.purpose, " C");
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "container-auction-book-visit",
        class: _normalizeClass(_ctx.isModal ? '' : 'tw-mb-20px tw-p-20px tw-bg-w-cultured tw-border-[1px] tw-rounded')
      }, [!_ctx.isModal ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        class: "tw-text-18 tw-mb-20px",
        innerHTML: _ctx.labels.title
      }, null, 8 /* PROPS */, _hoisted_1)) : _createCommentVNode("v-if", true), _createCommentVNode(" NAME "), _createElementVNode("div", _hoisted_2, [_createVNode(BaseInput, {
        modelValue: requestData.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => requestData.value.name = $event),
        "data-cy": "name-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.name),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_name
        },
        type: "name",
        name: "name",
        "label-text": _ctx.labels.name
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" SURNAME "), _createElementVNode("div", _hoisted_3, [_createVNode(BaseInput, {
        modelValue: requestData.value.surname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => requestData.value.surname = $event),
        "data-cy": "surname-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.surname),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_surname
        },
        type: "surname",
        name: "surname",
        "label-text": _ctx.labels.surname
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" EMAIL "), _createElementVNode("div", _hoisted_4, [_createVNode(BaseInput, {
        modelValue: requestData.value.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => requestData.value.email = $event),
        "data-cy": "email-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.email),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_mail
        },
        type: "email",
        name: "email",
        "label-text": _ctx.labels.email
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" PHONE "), _createElementVNode("div", _hoisted_5, [_createVNode(BaseInput, {
        modelValue: requestData.value.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => requestData.value.phone = $event),
        "data-cy": "phone-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.phone),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_phone
        },
        type: "phone",
        name: "phone",
        "label-text": _ctx.labels.phone
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" PRIVACY "), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        innerHTML: readAndAcceptedByClicking.value
      }, null, 8 /* PROPS */, _hoisted_7), _createElementVNode("span", {
        innerHTML: _ctx.labels.privacy_policy
      }, null, 8 /* PROPS */, _hoisted_8), _createTextVNode(" ("), _createElementVNode("a", {
        class: "tw-underline-offset-1",
        href: "#",
        onclick: "(function(e){e.preventDefault(); window.open('/privacy','_blank', 'scrollbars=yes, width=550, height=600'); })(event)",
        innerHTML: privacy_C_section.value
      }, null, 8 /* PROPS */, _hoisted_9), _createTextVNode(") "), _hoisted_10]), _ctx.isModal ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.guardian ? (_openBlock(), _createBlock(CustodianSupervisorCard, {
        key: 0,
        id: "container-auction-custodian-modal",
        "is-phone-showed": !_ctx.supervisor && !_ctx.isExtraConsultantActive,
        "agency-item": _ctx.guardian,
        "real-estate-id": _ctx.realEstateId,
        "place-id": _ctx.placeId,
        price: _ctx.productPrice,
        "typology-name": _ctx.typologyName,
        labels: {
          title: _ctx.labels.guardian,
          phone: _ctx.labels.phone
        }
      }, null, 8 /* PROPS */, ["is-phone-showed", "agency-item", "real-estate-id", "place-id", "price", "typology-name", "labels"])) : _createCommentVNode("v-if", true), _ctx.supervisor ? (_openBlock(), _createBlock(CustodianSupervisorCard, {
        key: 1,
        id: "container-auction-custodian-modal",
        "is-phone-showed": !_ctx.isExtraConsultantActive,
        "agency-item": _ctx.supervisor,
        "real-estate-id": _ctx.realEstateId,
        "place-id": _ctx.placeId,
        price: _ctx.productPrice,
        "typology-name": _ctx.typologyName,
        labels: {
          title: _ctx.labels.supervisor,
          phone: _ctx.labels.phone
        }
      }, null, 8 /* PROPS */, ["is-phone-showed", "agency-item", "real-estate-id", "place-id", "price", "typology-name", "labels"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createVNode(BaseButton, {
        id: "auction-btn-book-visit",
        "data-cy": "auction-btn-book-visit",
        "btn-class": "tw-btn tw-btn-w-primary tw-btn-sm tw-text-center tw-w-full",
        "is-loading": pvpRedirectIsLoading.value,
        onClick: _cache[4] || (_cache[4] = $event => redirectToPvp())
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-loading"])], 2 /* CLASS */);
    };
  }
});